export default __webpack_public_path__ + "static/media/nhalogo.e97dec9a.png";